<template>
  <div class="present">
    <div class="present-arrows">
      <img src="../assets/arrows.png" alt="" />
    </div>
    <div
      class="present-zt"
      v-for="(item, i) in list"
      :key="i"
      :style="{
        backgroundImage: nuber == i ? `url(${images})` : `url(${image})`,
      }"
      @click="website(i)"
    >
      <p class="span">{{ item.name }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "towbotM",
  data() {
    return {
      nuber: 0,
      list: [{ name: "场景全览" }, { name: "地下管网" }],
      image: require("../assets/Scenealong.png"),
      images: require("../assets/everything.png"),
    };
  },
  methods: {
    website(w) {
       this.emit.$emit("back");
        this.nuber = w;
      switch (w) {
        case 1:
          document.getElementById("iframe").contentWindow.MMAPI.transparent();
          break;
        case 0:
          document.getElementById("iframe").contentWindow.MMAPI.recover();
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.present {
  padding: 0.2vh 0.5vw;
  position: absolute;
  right: 2%;
  top: 50%;
  .Zindex();
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .present-zt {
    width: 6vw;
    height: 2.5vw;
    background-repeat: no-repeat;
    background-size: 100% auto;
    text-align: center;
    cursor: pointer;
    .span {
      margin-top: 2vh;
      font-size: 0.8vw;
    }
  }
}
</style>